import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-navy text-white/70" data-id="element-88" data-mp="3gfsmscqd8umz">
      <div className="h-1.5 w-full bg-leaf" aria-hidden="true" data-id="element-89" data-mp="3ggu1cr6lbz9g" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-90" data-mp="32onjn0nshk7w">
        <p className="font-display text-lg font-extrabold uppercase text-white" data-id="element-91" data-mp="36pft9v0kpr4p">{productShortName}</p>
        <p className="mt-3 text-sm" data-id="element-92" data-mp="3uf0nxb63actt">Created by environmental education specialists, for educators worldwide.</p>
        <p className="mt-6 border-t border-white/15 pt-6 text-xs" data-id="element-93" data-mp="38h7nghhhuo4">
          © 2026 {productShortName} — All rights reserved.
        </p>
      </div>
    </footer>;
}